import type { RacketType } from "../graphql";

export const DEFAULT_RACKET_TYPE: RacketType = "TENNIS";

// Adding a RacketType value makes each of the maps below fail to compile until it is handled.
export const RACKET_TYPE_LABELS = {
  TENNIS: "Tennis",
  RACQUETBALL: "Racquetball",
} as const satisfies Record<RacketType, string>;

// Whether job tables flag the type with a badge; tennis is the unmarked default.
export const RACKET_TYPE_SHOWS_BADGE = {
  TENNIS: false,
  RACQUETBALL: true,
} as const satisfies Record<RacketType, boolean>;

// Display order for the segmented control.
const RACKET_TYPES = [
  "TENNIS",
  "RACQUETBALL",
] as const satisfies readonly RacketType[];

// Fails to compile if RACKET_TYPES is missing a RacketType.
const _racketTypesAreComplete: [
  Exclude<RacketType, (typeof RACKET_TYPES)[number]>,
] extends [never]
  ? true
  : never = true;
void _racketTypesAreComplete;

export const RACKET_TYPE_OPTIONS = RACKET_TYPES.map((value) => ({
  value,
  label: RACKET_TYPE_LABELS[value],
}));

export function isRacketType(value: string): value is RacketType {
  return Object.prototype.hasOwnProperty.call(RACKET_TYPE_LABELS, value);
}

export function racketTypeFromParam(
  value: string | null
): RacketType | undefined {
  return value !== null && isRacketType(value) ? value : undefined;
}
